import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, Inject } from '@angular/core';


@Component({
  selector: 'app-recurringconfirm',
  templateUrl: './recurringconfirm.component.html',
  styleUrls: ['./recurringconfirm.component.sass']
})
export class RecurringconfirmDialogComponent {
  selectedId: number;
  appointment: string;
  confirmationType: string;
  providerName: string;

  constructor(
    public confirmdialogRef: MatDialogRef<RecurringconfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    confirmdialogRef.disableClose = true;
  }
  onOkClick(): void {
    this.confirmdialogRef.close(2);
  }

  onCancel(): void {
    this.confirmdialogRef.close();    
  }

  confirmUpdateOccurance(): void {
   this.confirmdialogRef.close(1);
  }
}
